import { render, staticRenderFns } from "./StoreGoiPromoDataGrid.vue?vue&type=template&id=04a400c6&scoped=true"
import script from "./StoreGoiPromoDataGrid.vue?vue&type=script&lang=js"
export * from "./StoreGoiPromoDataGrid.vue?vue&type=script&lang=js"
import style0 from "./StoreGoiPromoDataGrid.vue?vue&type=style&index=0&id=04a400c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a400c6",
  null
  
)

export default component.exports